import styled from 'styled-components';
import {Link} from "gatsby";

const StyledBlogList = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: space-between;
  margin-top: 52px;
`;

const StyledPost = styled(Link)`
  width: 100%;
  margin-bottom: 52px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  flex-direction: row;
  background-color: transparent;
  padding: 24px;
  transition: 0.3s ease-in-out;
  text-decoration: none;
  color: #000;
  :hover {
    background-color: ${({theme}) => theme.color.hoverGray};
  }
  @media (max-width: 500px) {
    flex-direction: column;
  }
  div {
    max-width: 45vw;
    @media (max-width: 500px) {
      max-width: 100vw;
    }
  }
  h2 {
    font-weight: normal;
  }
  p {
  line-height: 1.3rem;
  }
`;

const StyledInnerPost = styled.div`
  display: flex;
  align-items: flex-end;
  align-content: flex-end;
  flex-direction: column;
`;

export {StyledBlogList, StyledPost, StyledInnerPost};
